import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/chevronLeft.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-79829508")

_pushScopeId("data-v-79829508")
const _hoisted_1 = { class: "reservation_calendar genericPadding hasHeader" }
const _hoisted_2 = { class: "header withShadow d-flex aling-items-center justify-content-between py-4" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "sideContainer" }, null, -1)
const _hoisted_5 = { class: "datesSlider" }
const _hoisted_6 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_7 = { class: "fs_14 spaceCadet text-uppercase" }
const _hoisted_8 = /*#__PURE__*/_createVNode("img", {
  style: {"transform":"rotate(180deg)"},
  src: _imports_0
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_calendar = _resolveComponent("calendar")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: "sideContainer",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.back()))
      }, [
        _hoisted_3
      ]),
      _createVNode(_component_localized_text, {
        class: "fs_12 greyBlue",
        localizedKey: "app_calendario",
        text: "Calendario"
      }),
      _hoisted_4
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode("button", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeMonth(true)))
      }, [
        _hoisted_6
      ]),
      _createVNode("span", _hoisted_7, _toDisplayString(_ctx.$filters.date(_ctx.selectedMonth, "MMMM YYYY")), 1),
      _createVNode("button", {
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeMonth(false)))
      }, [
        _hoisted_8
      ])
    ]),
    _createVNode(_component_calendar, {
      value: _ctx.selectedMonth,
      onDayClicked: _ctx.dayClicked
    }, null, 8, ["value", "onDayClicked"])
  ]))
})